import _ from 'lodash'
import { formatSFMappingResult, ftGetLocalStorage } from '../../lib/common'
import { getAxios, getPreviewDynamicData, fturl, isDisabledSfIntegration } from '../../lib/projectAxios'
import * as actionTypes from './actionTypes'
import { recursivePrepareSFMapping } from './recursivePrepareSFMapping'
import uuid from 'uuid/v4'
import { SURVEY_TYPE } from '../../constants/features'
import { processSFItemCancel, processSFItemCancelClear } from './processCondCache'
import {
  asyncIsAllowProcessSFFetchCacheData,
  isAllowProcessSFFetchCacheData,
  processSFFetchCacheData,
} from './pwa-tools'
import {
  SESSION_HEADER_NAME,
  SESSION_HEADER_SALT,
  SESSION_SALT_NAME,
  SESSION_TOKEN_NAME,
} from '../../constants/session'
const axios = getAxios()

const clearCancelled = (keys) => (dispatch, getState) => {
  let nextState = getState()
  _.each(keys, (key) => {
    nextState = nextState.deleteIn(['__cond__cache__', 'list', key]).deleteIn(['__cond__cache__', 'nodes', key])
  })
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: nextState,
    },
  })
}

export const processWidgetCustomSFItem = async (
  sfMapping,
  state,
  conf,
  widgetsData,
  params,
  hashCustomActions,
  dispatch
) => {
  let allowOffline =
    state.getIn(['project', 'Settings', 'allowOffline'], false) || (await asyncIsAllowProcessSFFetchCacheData(state))
  let messages = []
  let list = recursivePrepareSFMapping(
    sfMapping,
    'custom',
    [],
    widgetsData,
    params,
    false,
    messages,
    hashCustomActions,
    conf
  )
  if (!Object.keys(list).length) {
    return false
  }
  if (conf.runInBackground) {
    messages = []
  }

  try {
    if (isDisabledSfIntegration('get', list)) {
      return false
    }
  } catch (err) {
    console.error(err)
  }

  if (!conf.runInBackground && messages.length > 0) {
    dispatch({
      type: actionTypes.SHOW_LOADING_WINDOW,
      payload: {
        messages: messages,
      },
    })
  }

  let guid = _.get(getPreviewDynamicData(), ['guid'])
  let ruleUID = null
  if (state.get('isNoBackGroundLoad')) {
    guid = null
  } else if (window && conf.ruleUID) {
    if (!window.processedOnload) {
      window.processedOnload = {}
    }
    if (!window.processedOnload[conf.ruleUID]) {
      window.processedOnload[conf.ruleUID] = true
      ruleUID = conf.ruleUID
    } else {
      guid = null
    }
  } else {
    guid = null
  }
  if (isAllowProcessSFFetchCacheData(state)) {
    return dispatch(processSFFetchCacheData(list, conf.index))
  }
  if (conf.isParallelLoad && window.EventSource) {
    try {
      if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
        console.log('custom action sf get >>> ', Object.keys(list))
      }
      let requestGID = uuid()
      if (!window.processingRequest) {
        window.processingRequest = {}
      }
      window.processingRequest[requestGID] = true
      const recursiveProcessSSe = (attemp) => {
        if (attemp >= 3) {
          asyncIsAllowProcessSFFetchCacheData(state).then((status) => {
            if (status) {
              dispatch(processSFFetchCacheData(list))
            }
          })
          return false
        }
        let sessionStorage = {}
        try {
          const token = ftGetLocalStorage(SESSION_TOKEN_NAME)
          if (token) {
            sessionStorage[SESSION_HEADER_NAME] = token
          }
          const salt = ftGetLocalStorage(SESSION_SALT_NAME)
          if (salt) {
            sessionStorage[SESSION_HEADER_SALT] = salt
          }
        } catch (err) {}
        const sse = new EventSource(
          '/webprojects/get/sse/sfmapping?data=' +
            encodeURIComponent(
              JSON.stringify({
                list,
                ruleUID,
                guid,
                fturl,
                sfAuthHash: _.get(getPreviewDynamicData(), ['ssoParams', 'sfAuthHash']),
                ...sessionStorage,
              })
            ),
          { withCredentials: true }
        )
        return new Promise((resolve) => {
          let canceled = []
          let successData = []
          sse.addEventListener('pull-data', (e) => {
            let data = e.data
            if (data && Object.keys(data)) {
              try {
                data = JSON.parse(data)
                if (data) {
                  // data = formatSFMappingResult(data);
                  let isShowLoading = false
                  let loadingMessages = {}
                  if (data.data && _.size(data.data)) {
                    successData.push(true)
                  }
                  if (data && data?.messages && Object.keys(_.omit(data?.messages, ['canceled'])).length) {
                    isShowLoading = true
                    loadingMessages.type = 'error'
                    loadingMessages.isAlloClose = true
                    loadingMessages.list = []
                    _.each(_.omit(data.messages, ['canceled']), (msg) => {
                      loadingMessages.list.push(msg)
                    })
                  }
                  _.each(_.get(data, ['messages', 'canceled'], {}), (value, key) => {
                    canceled.push(key)
                  })
                  dispatch(clearCancelled(canceled))
                  dispatch({
                    type: actionTypes.PROCESS_SF_CHILD_MAPPING,
                    payload: {
                      path: [],
                      data: data,
                      repeatIndex: conf.index,
                      list: list,
                      isShowLoading,
                      loadingMessages,
                      sfMessages: _.omit(data?.messages, ['canceled']),
                      inQuery: true,
                      ignoreValidations: conf.ignoreValidations,
                    },
                  })

                  let displayElementsList = {}
                  _.each(list, (v, k) => {
                    displayElementsList[k] = k
                  })
                  if (_.isArray(data.item)) {
                    _.each(data.item, function (rowUID) {
                      displayElementsList[rowUID] = list[rowUID]
                    })
                  } else {
                    displayElementsList[data.item] = list[data.item]
                  }

                  if (state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE) {
                    dispatch({
                      type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
                      payload: {},
                    })
                  }
                  let cancelledObj = _.get(data, ['messages', 'canceled'], {})
                  if (!_.isObject(cancelledObj)) {
                    cancelledObj = {}
                  }
                  _.each(canceled, (uid) => {
                    if (cancelledObj?.[uid] !== true) {
                      cancelledObj[uid] = true
                    }
                  })
                  data = _.set(data, ['messages', 'canceled'], cancelledObj)
                  dispatch({
                    type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
                    payload: {
                      list: displayElementsList,
                      params: data?.messages,
                    },
                  })
                }
              } catch (error) {}
            }
          })
          sse.addEventListener('close', (e) => {
            if (_.size(canceled) && !_.size(successData)) {
              dispatch(processSFItemCancel(conf.processUID))
            }
            delete window.processingRequest[requestGID]
            dispatch({ type: actionTypes.CLOSE_LOADING_WINDOW })
            sse.close()
            resolve()
          })
          sse.onerror = (ev, e) => {
            console.log('onerror >>>', e)
            sse.close()
            resolve()
            if (ev && String(ev.data).indexOf('session_expired') > -1) {
              window.__FT_PROJECT__API__.navigateToSignInPage()
            } else {
              if (!allowOffline) {
                dispatch({
                  type: actionTypes.FETCH_DATA_ERROR,
                  payload: {
                    error: `You are offline, trying again in 2 seconds...`,
                  },
                })
              }
              setTimeout(function () {
                recursiveProcessSSe(attemp + 1)
              }, 2 * 1000)
            }
            if (attemp >= 2) {
              window.processingRequest = {}
              dispatch({
                type: actionTypes.CLOSE_LOADING_WINDOW,
              })
            }
          }
        })
      }
      await recursiveProcessSSe(0)
    } catch (error) {
      console.log('error >>>', error)
      dispatch({
        type: actionTypes.FETCH_DATA_ERROR,
        payload: {
          error: 'An error occurred, try again later',
        },
      })
      dispatch({
        type: actionTypes.CLOSE_LOADING_WINDOW,
      })
    }
  } else {
    try {
      if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
        console.log('custom action sf get >>> ', Object.keys(list))
      }

      let gCode
      if (conf.isVerifyCaptcha) {
        gCode = await window.__FT_PROJECT__API__.ftGetCaptchaToken()
        if (!gCode) {
          dispatch({
            type: actionTypes.PROCESS_SF_MAPPING,
            payload: {
              data: {},
              isShowLoading: false,
              loadingMessages: {},
              sfMessages: {},
            },
          })
          dispatch({
            type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
            payload: {
              list: list,
              params: data?.messages,
            },
          })
          return false
        }
      }

      let requestGID = uuid()
      if (!window.processingRequest) {
        window.processingRequest = {}
      }
      window.processingRequest[requestGID] = true

      const recursiveProcessGet = async (attemp) => {
        if (attemp >= 3) {
          return {
            status: 200,
            data: {
              status: false,
            },
          }
        }
        try {
          let result = await axios.post('/webprojects/get/sfmapping', {
            data: {
              list,
              ruleUID,
              processRule: conf.ruleUID,
              elemUID: conf.elemUID,
              guid,
              gCode,
            },
          })
          return result
        } catch (err) {
          console.log('err >>> ', err)
          if (!allowOffline) {
            dispatch({
              type: actionTypes.NOTIFY_ERROR,
              payload: {
                key: uuid(),
                message: `You are offline, trying again in 2 seconds...`,
              },
            })
          }
          await new Promise((resolve) => {
            setTimeout(resolve, 2 * 1000)
          })

          return recursiveProcessGet(attemp + 1)
        }
      }

      let { status, data } = await recursiveProcessGet(0)
      delete window.processingRequest[requestGID]
      if (!data.status) {
        if (data.error == 'captcha_denied') {
          dispatch({
            type: actionTypes.PROCESS_SF_MAPPING,
            payload: {
              data: {},
              isShowLoading: false,
              loadingMessages: {},
              sfMessages: {},
              captchaElem: conf.elemUID,
            },
          })
        } else if (data.error == 'session_expired') {
          if (state.get('page') == 'signin') {
            return false
          }
          if (state.get('page') != 'signin') {
            window.__FT_PROJECT__API__.navigateToSignInPage()
          }
          dispatch({
            type: actionTypes.PROCESS_SF_MAPPING,
            payload: {
              data: {},
              isShowLoading: false,
              loadingMessages: {},
              sfMessages: {},
            },
          })
          return false
        } else {
          let status = await asyncIsAllowProcessSFFetchCacheData(state)
          if (status) {
            return dispatch(processSFFetchCacheData(list))
          }
        }
      }

      // data = formatSFMappingResult(data);

      let isShowLoading = false
      let loadingMessages = {}
      if (data && data.messages && Object.keys(_.omit(data?.messages, ['canceled'])).length) {
        isShowLoading = true
        loadingMessages.type = 'error'
        loadingMessages.isAlloClose = true
        loadingMessages.list = []
        _.each(_.omit(data?.messages, ['canceled']), (msg) => {
          loadingMessages.list.push(msg)
        })
      }

      if (_.size(data?.messages?.canceled) > 0 && _.isEmpty(data?.data)) {
        dispatch(processSFItemCancel(conf.processUID))
      }

      dispatch({
        type: actionTypes.PROCESS_SF_CHILD_MAPPING,
        payload: {
          // path: isPortal
          //     ? conf.widgetPath
          //     : _.slice(conf.widgetPath, 0, conf.widgetPath.length - 1),
          path: [],
          list: list,
          repeatIndex: conf.index,
          data,
          isShowLoading,
          loadingMessages,
          sfMessages: _.omit(data?.messages, ['canceled']),
          inQuery: true,
          ignoreValidations: conf.ignoreValidations,
        },
      })

      if (state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE) {
        dispatch({
          type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
          payload: {},
        })
      }

      requestAnimationFrame(() => {
        dispatch({
          type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
          payload: {
            list: list,
            params: data?.messages,
          },
        })
      })
    } catch (error) {
      console.error(error)
      dispatch({
        type: actionTypes.FETCH_DATA_ERROR,
        payload: {
          error: 'An error occurred, try again later',
        },
      })
      dispatch({
        type: actionTypes.CLOSE_LOADING_WINDOW,
      })
    }
  }
}
